import globals from '../../globals'

import styles from './Subtitle.css'

class Subtitle extends HTMLElement {
  public connectedCallback (): void {
    this.appendChild(
      <div className={ styles.subtitle }>
        <h2 className={ styles.text }>{ globals.subtitle }</h2>
      </div>
    )
  }
}

customElements.define('a-subtitle', Subtitle)
